import { render, staticRenderFns } from "./RegistroBeneficiario.vue?vue&type=template&id=54c1ca80&scoped=true"
import script from "./RegistroBeneficiario.vue?vue&type=script&lang=ts"
export * from "./RegistroBeneficiario.vue?vue&type=script&lang=ts"
import style0 from "./RegistroBeneficiario.vue?vue&type=style&index=0&id=54c1ca80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1ca80",
  null
  
)

export default component.exports